<ng-container *ngIf="routeReady">
  <ng-container *ngIf="!isPublic; else publicView">
    <app-header></app-header>
    <div class="h-fit">
      <app-sidebar></app-sidebar>
      <div class="px-2 pt-2">
        <router-outlet></router-outlet>
        <app-footer *ngIf="!isTeamInbox"></app-footer>
      </div>
    </div>
  </ng-container>
  <app-loader></app-loader>
  <!-- public -->
  <ng-template #publicView>
    <router-outlet></router-outlet>
  </ng-template>
</ng-container>
